module.exports = __webpack_public_path__ + "img/logo@2x.351834a7.png";